import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Meteor } from 'meteor/meteor';
import { cloneDeep, forEach, get, isEmpty, isEqual, isNil } from 'lodash';
import { Bert } from 'meteor/themeteorchef:bert';
import uuid from 'uuid/v1';
import turf from '@turf/turf';

import { Row, Col } from 'react-bootstrap';
import * as layerOps from '../../../api/Layers/layer-operations';
import * as mapOps from '../../../api/Maps/map-operations';

import {
  featurePoint2LatLng,
  featureGetZoom,
  latlong2featurePoint,
  featureSetZoom,
  featureSetBBox
} from '../../../modules/geojson-utilities';
import handleErrorInClient from '../../../modules/handle-error-in-client';
import methodPromise from '../../../modules/method-promise-wrapper';

import ButtonOnMap from '../ButtonOnMap';
import LeafletMap from '../../components/LeafletMap';
import LeafletMapSecondSync from '../../components/LeafletMapSecondSync';

const { defaultMapCenter } = Meteor.settings.public;
const oldLayers = [];
const oldMap = [];

let customHomeButton;
let drawCustomButtons;
let drawMapLayers;
let getBBoxFromCoordsAndZoom;
let getMapCenter;
let L;
let MiniMap;
let addDrawEventListenersMaps;
let createGeometryDrawControlsMaps;
let drawMapInterestArea;
let showGeometryEditControls;
let intervaloFunction;
let intervaloGoToFunction;
let marker;
let circle;
let intervaloFunctionSecond;
let intervaloGoToFunctionSecond;
let markerSecond;
let circleSecond;
let estado = false;
let initializeLoaded = true;

class MapContainerSyncMap extends Component {
  aiInterestAreaDrawControl = null;

  aiInterestAreaEditControl = null;

  aiInterestAreaLayer = null;

  baseMapsToDisplay = null;

  baseMapsToDisplaySecond = null;

  layersToDisplay = null;

  layersToDisplaySecond = null;

  mapMap = null;

  mapMapSecond = null;

  mapMapComponent = React.createRef();

  mapMapComponentSecond = React.createRef();

  mapSecondInterestAreaDrawControl = null;

  mapSecondInterestAreaEditControl = null;

  mapSecondInterestAreaLayer = null;

  randomMapId = uuid();

  state = {
    aiInterestArea: {},
    clientModulesReady: false,
    currentLocationState: false,
    goToState: false,
    currentLocationStateSecond: false,
    goToStateSecond: false,
    isLeafletMapLoaded: get(this, 'mapMapComponent.current.state.isMapLoaded', false),
    isLeafletSecondMapLoaded: get(this, 'mapMapComponent.current.state.isSecondMapLoaded', false),
    isMapMapLoaded: false,
    isSecondMapLoaded: false,
    mapSecondInterestArea: {}
  };

  componentDidMount() {
    const { clientModulesReady } = this.state;
    if (!clientModulesReady) {
      this.loadClientModules();
    }
  }

  async componentDidUpdate(prevProps, prevState) {
    const { baseMaps, isAtlas, layers, map, popupProp } = this.props;
    const {
      aiInterestArea,
      clientModulesReady,
      currentLocationState,
      currentLocationStateSecond,
      goToState,
      goToStateSecond,
      isLeafletMapLoaded,
      isLeafletSecondMapLoaded,
      isMapMapLoaded,
      isSecondMapLoaded,
      mapSecondInterestArea
    } = this.state;
    const { layers: prevLayers, baseMaps: prevBaseMaps, map: prevMap } = prevProps;
    const {
      currentLocationState: prevCurrentLocationState,
      currentLocationSecond: prevCurrentLocationStateSecond,
      aiInterestArea: prevAIInterestArea,
      mapSecondInterestArea: prevMapSecondInterestArea,
      goToState: prevGoToState,
      goToStateSecond: prevGoToStateSecond
    } = prevState;
    let forceupdate = false;
    let forceupdateMap = false;
    let forceupdateLeafletButton = false;
    const hasSharedUpdated = mapOps.isShared(prevMap) !== mapOps.isShared(map);

    const hasMapCenterUpdated = !isEqual(
      mapOps.getMapLocation(prevMap),
      mapOps.getMapLocation(map)
    );

    const haveSelectedButtonsChanged = !isEqual(
      mapOps.getSelectedButtons(prevMap),
      mapOps.getSelectedButtons(map)
    );
    const areButtonsUpdated = hasSharedUpdated || hasMapCenterUpdated || haveSelectedButtonsChanged;
    if (
      clientModulesReady &&
      isLeafletMapLoaded &&
      isLeafletSecondMapLoaded &&
      !isMapMapLoaded &&
      !isSecondMapLoaded &&
      initializeLoaded
    ) {
      initializeLoaded = false;
      this.initializeMap();
    }
    if (isMapMapLoaded && !isEqual(mapOps.getBackground(map), mapOps.getBackground(prevMap))) {
      const mapId = isAtlas ? this.randomMapId : 'mapMap';
      document.getElementById(mapId).style.background = mapOps.getBackground(map);
    }

    if (!isEqual(layers, oldLayers[0])) {
      forceupdate = true;
      oldLayers[0] = cloneDeep(layers);
    } else {
      forceupdate = false;
    }

    if (!isEqual(map, oldMap[0])) {
      forceupdateMap = true;
      oldMap[0] = cloneDeep(map);
    } else {
      forceupdateMap = false;
    }
    if (
      !isEqual(prevCurrentLocationState, currentLocationState) ||
      !isEqual(prevCurrentLocationStateSecond, currentLocationStateSecond) ||
      !isEqual(prevGoToState, goToState) ||
      !isEqual(prevGoToStateSecond, goToStateSecond)
    ) {
      forceupdateLeafletButton = true;
    } else {
      forceupdateLeafletButton = false;
    }

    if (isMapMapLoaded && isSecondMapLoaded) {
      estado =
        !isEqual(prevLayers, layers) ||
        !isEqual(prevBaseMaps, baseMaps) ||
        forceupdate === true ||
        forceupdateMap === true;
      if (estado === true) {
        const leafletObjectResults = await drawMapLayers({
          layers,
          baseMaps,
          popupProp,
          leafletMap: this.mapMap,
          layersOverlayed: mapOps.areLayersOverlayed(map),
          layersToDisplay: this.layersToDisplay,
          baseMapsToDisplay: this.baseMapsToDisplay,
          isUpdate: true,
          baseMapsTransparency: mapOps.getBaseMapsTransparency(map),
          layersTransparency: mapOps.getLayersTransparency(map),
          baseMapsZoom: mapOps.getBaseMapsZoom(map),
          layersZoom: mapOps.getLayersZoom(map),
          layerVisibilitySettings: mapOps.getLayersVisibility(map)
        });
        this.layersToDisplay = leafletObjectResults.newLayersToDraw;
        this.baseMapsToDisplay = leafletObjectResults.newBaseMapsToDraw;
        drawCustomButtons({
          map,
          type: 'map',
          leafletMap: this.mapMap,
          layers,
          layersToDisplay: this.layersToDisplay,
          baseMaps,
          baseMapsToDisplay: this.baseMapsToDisplay,
          baseMapsZoom: mapOps.getBaseMapsZoom(map),
          layersZoom: mapOps.getLayersZoom(map),
          reloadButton: true,
          reloadFunction: this.reloadMapMap,
          locationButton: true,
          currentLocationState,
          locationFunction: this.currentLocation,
          goToState,
          gotoLocationButton: true,
          gotoLocationFunction: this.gotoLocation
        });
        drawMapInterestArea({
          aiInterestArea,
          aiInterestAreaLayer: this.aiInterestAreaLayer,
          isUpdate: true,
          leafletMap: this.mapMap
        });
        if (!isEmpty(aiInterestArea)) {
          this.mapMap.removeControl(this.aiInterestAreaDrawControl);
        }
        showGeometryEditControls({
          leafletMap: this.mapMap,
          drawControl: this.aiInterestAreaDrawControl,
          editControl: this.aiInterestAreaEditControl,
          defineGeometryActive: true,
          geometryLayer: this.aiInterestAreaLayer
        });
        const leafletObjectResultsSecond = await drawMapLayers({
          layers,
          baseMaps,
          popupProp,
          leafletMap: this.mapMapSecond,
          layersOverlayed: mapOps.areLayersOverlayed(map),
          layersToDisplay: this.layersToDisplaySecond,
          baseMapsToDisplay: this.baseMapsToDisplaySecond,
          isUpdate: true,
          baseMapsTransparency: mapOps.getBaseMapsTransparency(map),
          layersTransparency: mapOps.getLayersTransparency(map),
          baseMapsZoom: mapOps.getBaseMapsZoom(map),
          layersZoom: mapOps.getLayersZoom(map),
          layerVisibilitySettings: mapOps.getLayersVisibility(map)
        });
        this.layersToDisplaySecond = leafletObjectResultsSecond.newLayersToDraw;
        this.baseMapsToDisplaySecond = leafletObjectResultsSecond.newBaseMapsToDraw;
        drawCustomButtons({
          map,
          type: 'map',
          leafletMap: this.mapMapSecond,
          layers,
          layersToDisplay: this.layersToDisplaySecond,
          baseMaps,
          baseMapsToDisplay: this.baseMapsToDisplaySecond,
          baseMapsZoom: mapOps.getBaseMapsZoom(map),
          layersZoom: mapOps.getLayersZoom(map),
          reloadButton: true,
          reloadFunction: this.reloadMapMapSecond,
          currentLocationState: currentLocationStateSecond,
          locationFunction: this.currentLocationSecond,
          goToState: goToStateSecond,
          gotoLocationButton: true,
          gotoLocationFunction: this.gotoLocationSecond
        });
        drawMapInterestArea({
          aiInterestArea: mapSecondInterestArea,
          aiInterestAreaLayer: this.mapSecondInterestAreaLayer,
          isUpdate: true,
          leafletMap: this.mapMapSecond
        });
        if (!isEmpty(aiInterestArea)) {
          this.mapMapSecond.removeControl(this.mapSecondInterestAreaDrawControl);
        }
        showGeometryEditControls({
          leafletMap: this.mapMapSecond,
          drawControl: this.mapSecondInterestAreaDrawControl,
          editControl: this.mapSecondInterestAreaEditControl,
          defineGeometryActive: true,
          geometryLayer: this.mapSecondInterestAreaLayer
        });
      } else if (areButtonsUpdated || forceupdateLeafletButton === true) {
        drawCustomButtons({
          map,
          type: 'map',
          leafletMap: this.mapMap,
          layers,
          layersToDisplay: this.layersToDisplay,
          baseMaps,
          baseMapsToDisplay: this.baseMapsToDisplay,
          baseMapsZoom: mapOps.getBaseMapsZoom(map),
          layersZoom: mapOps.getLayersZoom(map),
          reloadButton: true,
          reloadFunction: this.reloadMapMap,
          locationButton: true,
          currentLocationState,
          locationFunction: this.currentLocation,
          goToState,
          gotoLocationButton: true,
          gotoLocationFunction: this.gotoLocation
        });
        if (
          (!isEqual(aiInterestArea, prevAIInterestArea) || forceupdateLeafletButton === true) &&
          estado === false
        ) {
          drawMapInterestArea({
            aiInterestArea,
            aiInterestAreaLayer: this.aiInterestAreaLayer,
            isUpdate: true,
            leafletMap: this.mapMap
          });
          if (!isEmpty(aiInterestArea)) {
            this.mapMap.removeControl(this.aiInterestAreaDrawControl);
          }
          showGeometryEditControls({
            leafletMap: this.mapMap,
            drawControl: this.aiInterestAreaDrawControl,
            editControl: this.aiInterestAreaEditControl,
            defineGeometryActive: true,
            geometryLayer: this.aiInterestAreaLayer
          });
          this.expandirDesplegable();
        }
        drawCustomButtons({
          map,
          type: 'map',
          leafletMap: this.mapMapSecond,
          layers,
          layersToDisplay: this.layersToDisplaySecond,
          baseMaps,
          baseMapsToDisplay: this.baseMapsToDisplaySecond,
          baseMapsZoom: mapOps.getBaseMapsZoom(map),
          layersZoom: mapOps.getLayersZoom(map),
          reloadButton: true,
          reloadFunction: this.reloadMapMapSecond,
          currentLocationState: currentLocationStateSecond,
          locationButton: true,
          locationFunction: this.currentLocationSecond,
          goToState: goToStateSecond,
          gotoLocationButton: true,
          gotoLocationFunction: this.gotoLocationSecond
        });
        if (
          (!isEqual(mapSecondInterestArea, prevMapSecondInterestArea) ||
            forceupdateLeafletButton === true) &&
          estado === false
        ) {
          drawMapInterestArea({
            aiInterestArea: mapSecondInterestArea,
            aiInterestAreaLayer: this.mapSecondInterestAreaLayer,
            isUpdate: true,
            leafletMap: this.mapMapSecond
          });
          if (!isEmpty(mapSecondInterestArea)) {
            this.mapMapSecond.removeControl(this.mapSecondInterestAreaDrawControl);
          }
          showGeometryEditControls({
            leafletMap: this.mapMapSecond,
            drawControl: this.mapSecondInterestAreaDrawControl,
            editControl: this.mapSecondInterestAreaEditControl,
            defineGeometryActive: true,
            geometryLayer: this.mapSecondInterestAreaLayer
          });
          this.expandirDesplegableSecond();
        }
      }
    }
  }

  componentWillUnmount() {
    const { baseMaps, layers } = this.props;
    forEach(layers, layer => {
      if (layerOps.isRealTime(layer) || layerOps.isAnnotationsRealTime(layer)) {
        this.layersToDisplay[layerOps.getName(layer)].stop();
        this.layersToDisplaySecond[layerOps.getName(layer)].stop();
      }
    });
    forEach(baseMaps, baseMap => {
      if (layerOps.isRealTime(baseMap)) {
        this.baseMapsToDisplay[layerOps.getName(baseMap)].stop();
        this.baseMapsToDisplaySecond[layerOps.getName(baseMap)].stop();
      }
    });
  }

  getCurrentMapState = () => {
    return {
      itemType: 'leafletMap',
      leafletMap: this.mapMap,
      defineGeometryActive: true,
      geometryLayer: this.aiInterestAreaLayer,
      drawControl: this.aiInterestAreaDrawControl,
      editControl: this.aiInterestAreaEditControl,
      setAtlasGeometry: this.setAIInterestArea
    };
  };

  getCurrentMapStateSecond = () => {
    return {
      itemType: 'leafletMap',
      leafletMap: this.mapMapSecond,
      defineGeometryActive: true,
      geometryLayer: this.mapSecondInterestAreaLayer,
      drawControl: this.mapSecondInterestAreaDrawControl,
      editControl: this.mapSecondInterestAreaEditControl,
      setAtlasGeometry: this.setMapSecondInterestArea
    };
  };

  setAIInterestArea = newAIInterestArea => this.setState({ aiInterestArea: newAIInterestArea });

  setMapSecondInterestArea = newMapSecondInterestArea =>
    this.setState({ mapSecondInterestArea: newMapSecondInterestArea });

  expandirDesplegable = () => {
    this.mapMap.collapseButton.expand();
  };

  expandirDesplegableSecond = () => {
    this.mapMapSecond.collapseButton.expand();
  };

  updateMapCenter = async () => {
    const { isMapMapLoaded } = this.state;
    const { map } = this.props;
    if (isMapMapLoaded) {
      const currentMapCenter = latlong2featurePoint(this.mapMap.getCenter().wrap());
      featureSetZoom(currentMapCenter, this.mapMap.getZoom());
      featureSetBBox(
        currentMapCenter,
        getBBoxFromCoordsAndZoom({ map: this.mapMap, mapLocation: currentMapCenter })
      );
      try {
        await methodPromise('maps.updateMapLocation', mapOps.getId(map), currentMapCenter);
        if (mapOps.showHomeButton(map)) {
          this.mapMap.removeControl(this.mapMap.homeButton);
          customHomeButton(this.mapMap, currentMapCenter);
        }
        Bert.alert('Map Updated!', 'success');
      } catch (error) {
        handleErrorInClient(error);
      }
    } else {
      Bert.alert('Map Not Loaded!', 'warning');
    }
  };

  updateMapSecondCenter = async () => {
    const { isSecondMapLoaded } = this.state;
    const { map } = this.props;
    if (isSecondMapLoaded) {
      const currentMapCenter = latlong2featurePoint(this.mapMapSecond.getCenter().wrap());
      featureSetZoom(currentMapCenter, this.mapMapSecond.getZoom());
      featureSetBBox(
        currentMapCenter,
        getBBoxFromCoordsAndZoom({ map: this.mapMapSecond, mapLocation: currentMapCenter })
      );
      try {
        await methodPromise('maps.updateMapLocation', mapOps.getId(map), currentMapCenter);
        if (mapOps.showHomeButton(map)) {
          this.mapMapSecond.removeControl(this.mapMapSecond.homeButton);
          customHomeButton(this.mapMapSecond, currentMapCenter);
        }
        Bert.alert('Map Updated!', 'success');
      } catch (error) {
        handleErrorInClient(error);
      }
    } else {
      Bert.alert('Map Not Loaded!', 'warning');
    }
  };

  updateMapState = newState => {
    this.setState({ isLeafletMapLoaded: newState });
  };

  updateMapStateSecond = newState => {
    this.setState({ isLeafletSecondMapLoaded: newState });
  };

  calculateDrawGoToLocation = pos => {
    const radius = pos.coords.accuracy;
    marker = L.marker([pos.coords.latitude, pos.coords.longitude]).addTo(this.mapMap);
    circle = L.circle([pos.coords.latitude, pos.coords.longitude], radius, {
      color: 'blue',
      fillColor: 'blue'
    }).addTo(this.mapMap);
    this.mapMap.panTo([pos.coords.latitude, pos.coords.longitude]);
    intervaloGoToFunction = setInterval(this.actualizarGoToFunction, 5000);
  };

  actualizarGoToFunction = () => {
    const error = err => {
      console.warn(`ERROR(${err.code}): ${err.message}`);
    };
    const options = {
      enableHighAccuracy: false,
      timeout: 5000,
      maximumAge: 5000
    };
    navigator.geolocation.getCurrentPosition(this.calculateUpateGoTo, error, options);
  };

  calculateUpateGoTo = pos => {
    if (!isEmpty(marker)) {
      const from = turf.point([pos.coords.longitude, pos.coords.latitude]);
      // eslint-disable-next-line no-underscore-dangle
      const to = turf.point([marker._latlng.lng, marker._latlng.lat]);
      const options = { units: 'meters' };
      const distance = turf.distance(from, to, options);

      if (distance > 8) {
        this.mapMap.removeLayer(marker);
        this.mapMap.removeLayer(circle);
        const radius = pos.coords.accuracy;
        marker = L.marker([pos.coords.latitude, pos.coords.longitude]).addTo(this.mapMap);
        circle = L.circle([pos.coords.latitude, pos.coords.longitude], radius, {
          color: 'blue',
          fillColor: 'blue'
        }).addTo(this.mapMap);
        this.mapMap.panTo([pos.coords.latitude, pos.coords.longitude]);
      }
    }
  };

  gotoLocation = () => {
    const { currentLocationState, goToState, isMapMapLoaded } = this.state;

    const error = err => {
      console.warn(`ERROR(${err.code}): ${err.message}`);
    };
    const options = {
      enableHighAccuracy: false,
      // timeout: 5000,
      maximumAge: 5000
    };
    if (isMapMapLoaded) {
      if (goToState === false) {
        if (currentLocationState === true) {
          this.mapMap.removeLayer(marker);
          this.mapMap.removeLayer(circle);
          clearInterval(intervaloFunction);
          this.setState({ currentLocationState: false });
        }
        navigator.geolocation.getCurrentPosition(this.calculateDrawGoToLocation, error, options);
      } else {
        this.mapMap.removeLayer(marker);
        this.mapMap.removeLayer(circle);
        clearInterval(intervaloGoToFunction);
      }
    }
    this.setState({ goToState: !goToState });
  };

  calculateDrawLocation = pos => {
    const radius = pos.coords.accuracy;
    marker = L.marker([pos.coords.latitude, pos.coords.longitude]).addTo(this.mapMap);
    circle = L.circle([pos.coords.latitude, pos.coords.longitude], radius, {
      color: 'blue',
      fillColor: 'blue'
    }).addTo(this.mapMap);
    intervaloFunction = setInterval(this.actualizarFunction, 5000);
  };

  actualizarFunction = () => {
    const error = err => {
      console.warn(`ERROR(${err.code}): ${err.message}`);
    };
    const options = {
      enableHighAccuracy: false,
      // timeout: 5000,
      maximumAge: 5000
    };
    navigator.geolocation.getCurrentPosition(this.calculateUpate, error, options);
  };

  calculateUpate = pos => {
    if (!isEmpty(marker)) {
      const from = turf.point([pos.coords.longitude, pos.coords.latitude]);
      // eslint-disable-next-line no-underscore-dangle
      const to = turf.point([marker._latlng.lng, marker._latlng.lat]);
      const options = { units: 'meters' };
      const distance = turf.distance(from, to, options);

      if (distance > 8) {
        this.mapMap.removeLayer(marker);
        this.mapMap.removeLayer(circle);
        const radius = pos.coords.accuracy;
        marker = L.marker([pos.coords.latitude, pos.coords.longitude]).addTo(this.mapMap);
        circle = L.circle([pos.coords.latitude, pos.coords.longitude], radius, {
          color: 'blue',
          fillColor: 'blue'
        }).addTo(this.mapMap);
      }
    }
  };

  currentLocation = () => {
    const { currentLocationState, goToState, isMapMapLoaded } = this.state;
    const error = err => {
      console.warn(`ERROR(${err.code}): ${err.message}`);
    };
    const options = {
      enableHighAccuracy: false,
      // timeout: 5000,
      maximumAge: 5000
    };

    if (isMapMapLoaded) {
      if (currentLocationState === false) {
        if (goToState === true) {
          this.mapMap.removeLayer(marker);
          this.mapMap.removeLayer(circle);
          clearInterval(intervaloGoToFunction);
          this.setState({ goToState: false });
        }
        navigator.geolocation.getCurrentPosition(this.calculateDrawLocation, error, options);
        this.setState({ currentLocationState: true });
      } else {
        this.mapMap.removeLayer(marker);
        this.mapMap.removeLayer(circle);
        clearInterval(intervaloFunction);
      }
    }
    this.setState({ currentLocationState: !currentLocationState });
  };

  calculateDrawGoToLocationSecond = pos => {
    const radius = pos.coords.accuracy;
    markerSecond = L.marker([pos.coords.latitude, pos.coords.longitude]).addTo(this.mapMapSecond);
    circleSecond = L.circle([pos.coords.latitude, pos.coords.longitude], radius, {
      color: 'blue',
      fillColor: 'blue'
    }).addTo(this.mapMapSecond);
    this.mapMapSecond.panTo([pos.coords.latitude, pos.coords.longitude]);
    intervaloGoToFunctionSecond = setInterval(this.actualizarGoToFunctionSecond, 5000);
  };

  actualizarGoToFunctionSecond = () => {
    const error = err => {
      console.warn(`ERROR(${err.code}): ${err.message}`);
    };
    const options = {
      enableHighAccuracy: false,
      timeout: 5000,
      maximumAge: 5000
    };
    navigator.geolocation.getCurrentPosition(this.calculateUpateGoToSecond, error, options);
  };

  calculateUpateGoToSecond = pos => {
    if (!isEmpty(markerSecond)) {
      const from = turf.point([pos.coords.longitude, pos.coords.latitude]);
      // eslint-disable-next-line no-underscore-dangle
      const to = turf.point([markerSecond._latlng.lng, markerSecond._latlng.lat]);
      const options = { units: 'meters' };
      const distance = turf.distance(from, to, options);

      if (distance > 8) {
        this.mapMapSecond.removeLayer(markerSecond);
        this.mapMapSecond.removeLayer(circleSecond);
        const radius = pos.coords.accuracy;
        markerSecond = L.marker([pos.coords.latitude, pos.coords.longitude]).addTo(
          this.mapMapSecond
        );
        circleSecond = L.circle([pos.coords.latitude, pos.coords.longitude], radius, {
          color: 'blue',
          fillColor: 'blue'
        }).addTo(this.mapMapSecond);
        this.mapMapSecond.panTo([pos.coords.latitude, pos.coords.longitude]);
      }
    }
  };

  gotoLocationSecond = () => {
    const { currentLocationStateSecond, goToStateSecond, isSecondMapLoaded } = this.state;

    const error = err => {
      console.warn(`ERROR(${err.code}): ${err.message}`);
    };
    const options = {
      enableHighAccuracy: false,
      // timeout: 5000,
      maximumAge: 5000
    };
    if (isSecondMapLoaded) {
      if (goToStateSecond === false) {
        if (currentLocationStateSecond === true) {
          this.mapMapSecond.removeLayer(markerSecond);
          this.mapMapSecond.removeLayer(circleSecond);
          clearInterval(intervaloFunctionSecond);
          this.setState({ currentLocationStateSecond: false });
        }
        navigator.geolocation.getCurrentPosition(
          this.calculateDrawGoToLocationSecond,
          error,
          options
        );
      } else {
        this.mapMapSecond.removeLayer(markerSecond);
        this.mapMapSecond.removeLayer(circleSecond);
        clearInterval(intervaloGoToFunctionSecond);
      }
    }
    this.setState({ goToStateSecond: !goToStateSecond });
  };

  calculateDrawLocationSecond = pos => {
    const radius = pos.coords.accuracy;
    markerSecond = L.marker([pos.coords.latitude, pos.coords.longitude]).addTo(this.mapMapSecond);
    circleSecond = L.circle([pos.coords.latitude, pos.coords.longitude], radius, {
      color: 'blue',
      fillColor: 'blue'
    }).addTo(this.mapMapSecond);
    intervaloFunctionSecond = setInterval(this.actualizarFunctionSecond, 5000);
  };

  actualizarFunctionSecond = () => {
    const error = err => {
      console.warn(`ERROR(${err.code}): ${err.message}`);
    };
    const options = {
      enableHighAccuracy: false,
      // timeout: 5000,
      maximumAge: 5000
    };
    navigator.geolocation.getCurrentPosition(this.calculateUpateSecond, error, options);
  };

  calculateUpateSecond = pos => {
    if (!isEmpty(markerSecond)) {
      const from = turf.point([pos.coords.longitude, pos.coords.latitude]);
      // eslint-disable-next-line no-underscore-dangle
      const to = turf.point([markerSecond._latlng.lng, markerSecond._latlng.lat]);
      const options = { units: 'meters' };
      const distance = turf.distance(from, to, options);

      if (distance > 8) {
        this.mapMapSecond.removeLayer(markerSecond);
        this.mapMapSecond.removeLayer(circleSecond);
        const radius = pos.coords.accuracy;
        markerSecond = L.marker([pos.coords.latitude, pos.coords.longitude]).addTo(
          this.mapMapSecond
        );
        circleSecond = L.circle([pos.coords.latitude, pos.coords.longitude], radius, {
          color: 'blue',
          fillColor: 'blue'
        }).addTo(this.mapMapSecond);
      }
    }
  };

  currentLocationSecond = () => {
    const { currentLocationStateSecond, goToStateSecond, isSecondMapLoaded } = this.state;
    const error = err => {
      console.warn(`ERROR(${err.code}): ${err.message}`);
    };
    const options = {
      enableHighAccuracy: false,
      // timeout: 5000,
      maximumAge: 5000
    };

    if (isSecondMapLoaded) {
      if (currentLocationStateSecond === false) {
        if (goToStateSecond === true) {
          this.mapMapSecond.removeLayer(markerSecond);
          this.mapMapSecond.removeLayer(circleSecond);
          clearInterval(intervaloGoToFunction);
          this.setState({ goToStateSecond: false });
        }
        navigator.geolocation.getCurrentPosition(this.calculateDrawLocationSecond, error, options);
        this.setState({ currentLocationStateSecond: true });
      } else {
        this.mapMapSecond.removeLayer(markerSecond);
        this.mapMapSecond.removeLayer(circleSecond);
        clearInterval(intervaloFunctionSecond);
      }
    }
    this.setState({ currentLocationStateSecond: !currentLocationStateSecond });
  };

  initializeMap = async () => {
    const { baseMaps, isAtlas, layers, map, userControlSetting } = this.props;
    const {
      aiInterestArea,
      currentLocationState,
      currentLocationStateSecond,
      goToState,
      goToStateSecond,
      mapSecondInterestArea
    } = this.state;

    let mapLocation = mapOps.getMapLocation(map);
    if (isEmpty(mapLocation)) {
      if (!isNil(Meteor.user())) {
        mapLocation = userControlSetting.defaultMapCenter;
      } else {
        mapLocation = defaultMapCenter;
      }
    }

    this.mapMap = get(this, 'mapMapComponent.current.leafletMap');
    this.mapMap.setView(
      featurePoint2LatLng(getMapCenter({ location: mapLocation })),
      featureGetZoom(mapLocation)
    );
    this.mapMapSecond = get(this, 'mapMapComponentSecond.current.leafletSecondMap');
    this.mapMapSecond.setView(
      featurePoint2LatLng(getMapCenter({ location: mapLocation })),
      featureGetZoom(mapLocation)
    );
    const mapId = isAtlas ? this.randomMapId : 'mapMap';
    document.getElementById(mapId).style.background = mapOps.getBackground(map);

    const mapIdSecond = isAtlas ? this.randomMapId : 'mapMapSecond';
    document.getElementById(mapIdSecond).style.background = mapOps.getBackground(map);

    const leafletObjectResults = await drawMapLayers({
      layers,
      baseMaps,
      leafletMap: this.mapMap,
      layersOverlayed: mapOps.areLayersOverlayed(map),
      layersToDisplay: this.layersToDisplay,
      baseMapsToDisplay: this.baseMapsToDisplay,
      baseMapsTransparency: mapOps.getBaseMapsTransparency(map),
      layersTransparency: mapOps.getLayersTransparency(map),
      baseMapsZoom: mapOps.getBaseMapsZoom(map),
      layersZoom: mapOps.getLayersZoom(map),
      layerVisibilitySettings: mapOps.getLayersVisibility(map)
    });
    this.layersToDisplay = leafletObjectResults.newLayersToDraw;
    this.baseMapsToDisplay = leafletObjectResults.newBaseMapsToDraw;
    drawCustomButtons({
      map,
      type: 'map',
      leafletMap: this.mapMap,
      layers,
      layersToDisplay: this.layersToDisplay,
      baseMaps,
      baseMapsToDisplay: this.baseMapsToDisplay,
      baseMapsZoom: mapOps.getBaseMapsZoom(map),
      layersZoom: mapOps.getLayersZoom(map),
      reloadButton: true,
      reloadFunction: this.reloadMapMap,
      locationButton: true,
      currentLocationState,
      locationFunction: this.currentLocation,
      goToState,
      gotoLocationButton: true,
      gotoLocationFunction: this.gotoLocation
    });
    this.aiInterestAreaLayer = drawMapInterestArea({
      aiInterestArea,
      leafletMap: this.mapMap
    });

    const aiInterestAreaControls = createGeometryDrawControlsMaps({
      drawnItems: this.aiInterestAreaLayer
    });
    this.aiInterestAreaDrawControl = aiInterestAreaControls.drawControlFull;
    this.aiInterestAreaEditControl = aiInterestAreaControls.drawControlEdit;

    addDrawEventListenersMaps({
      limitation: false,
      // maximumarea: this.state.maximumarea,
      leafletMap: this.mapMap,
      getCurrentMapState: this.getCurrentMapState,
      editControl: this.aiInterestAreaEditControl
    });

    showGeometryEditControls({
      leafletMap: this.mapMap,
      drawControl: this.aiInterestAreaDrawControl,
      editControl: this.aiInterestAreaEditControl,
      defineGeometryActive: true,
      geometryLayer: this.aiInterestAreaLayer
    });
    const leafletObjectResultsSecond = await drawMapLayers({
      layers,
      baseMaps,
      leafletMap: this.mapMapSecond,
      layersOverlayed: mapOps.areLayersOverlayed(map),
      layersToDisplay: this.layersToDisplaySecond,
      baseMapsToDisplay: this.baseMapsToDisplaySecond,
      baseMapsTransparency: mapOps.getBaseMapsTransparency(map),
      layersTransparency: mapOps.getLayersTransparency(map),
      baseMapsZoom: mapOps.getBaseMapsZoom(map),
      layersZoom: mapOps.getLayersZoom(map),
      layerVisibilitySettings: mapOps.getLayersVisibility(map)
    });
    this.layersToDisplaySecond = leafletObjectResultsSecond.newLayersToDraw;
    this.baseMapsToDisplaySecond = leafletObjectResultsSecond.newBaseMapsToDraw;
    drawCustomButtons({
      map,
      type: 'map',
      leafletMap: this.mapMapSecond,
      layers,
      layersToDisplay: this.layersToDisplaySecond,
      baseMaps,
      baseMapsToDisplay: this.baseMapsToDisplaySecond,
      baseMapsZoom: mapOps.getBaseMapsZoom(map),
      layersZoom: mapOps.getLayersZoom(map),
      reloadButton: true,
      reloadFunction: this.reloadMapMapSecond,
      currentLocationState: currentLocationStateSecond,
      locationButton: true,
      locationFunction: this.currentLocationSecond,
      goToState: goToStateSecond,
      gotoLocationButton: true,
      gotoLocationFunction: this.gotoLocationSecond
    });
    this.mapSecondInterestAreaLayer = drawMapInterestArea({
      aiInterestArea: mapSecondInterestArea,
      leafletMap: this.mapMapSecond
    });

    const mapSecondInterestAreaControls = createGeometryDrawControlsMaps({
      drawnItems: this.mapSecondInterestAreaLayer
    });
    this.mapSecondInterestAreaDrawControl = mapSecondInterestAreaControls.drawControlFull;
    this.mapSecondInterestAreaEditControl = mapSecondInterestAreaControls.drawControlEdit;

    addDrawEventListenersMaps({
      limitation: false,
      // maximumarea: this.state.maximumarea,
      leafletMap: this.mapMapSecond,
      getCurrentMapState: this.getCurrentMapStateSecond,
      editControl: this.mapSecondInterestAreaEditControl
    });

    showGeometryEditControls({
      leafletMap: this.mapMapSecond,
      drawControl: this.mapSecondInterestAreaDrawControl,
      editControl: this.mapSecondInterestAreaEditControl,
      defineGeometryActive: true,
      geometryLayer: this.mapSecondInterestAreaLayer
    });

    this.mapMap.sync(this.mapMapSecond);
    this.mapMapSecond.sync(this.mapMap);
    if (mapOps.showMiniMap(map) === true) {
      const baseLayer = L.tileLayer(baseMaps[0].url, baseMaps[0].options || {});
      const miniMap = new MiniMap(baseLayer, {
        toggleDisplay: true,
        collapsedWidth: 25,
        collapsedHeight: 25,
        mapOptions: {
          dragging: false,
          scrollWheelZoom: false,
          doubleClickZoom: false,
          touchZoom: false
        }
      });
      miniMap.addTo(this.mapMap);
    }
    initializeLoaded = true;
    this.setState({ isMapMapLoaded: true, isSecondMapLoaded: true });
  };

  reloadMapMap = async () => {
    const { baseMaps, layers, map, popupProp, updateLayerMapState } = this.props;
    const { aiInterestArea, currentLocationState, goToState } = this.state;
    const leafletObjectResults = await drawMapLayers({
      layers,
      baseMaps,
      popupProp,
      leafletMap: this.mapMap,
      layersOverlayed: mapOps.areLayersOverlayed(map),
      layersToDisplay: this.layersToDisplay,
      baseMapsToDisplay: this.baseMapsToDisplay,
      isUpdate: true,
      baseMapsTransparency: mapOps.getBaseMapsTransparency(map),
      layersTransparency: mapOps.getLayersTransparency(map),
      baseMapsZoom: mapOps.getBaseMapsZoom(map),
      layersZoom: mapOps.getLayersZoom(map),
      layerVisibilitySettings: mapOps.getLayersVisibility(map)
    });
    this.layersToDisplay = leafletObjectResults.newLayersToDraw;
    this.baseMapsToDisplay = leafletObjectResults.newBaseMapsToDraw;
    drawCustomButtons({
      map,
      type: 'map',
      leafletMap: this.mapMap,
      layers,
      layersToDisplay: this.layersToDisplay,
      baseMaps,
      baseMapsToDisplay: this.baseMapsToDisplay,
      baseMapsZoom: mapOps.getBaseMapsZoom(map),
      layersZoom: mapOps.getLayersZoom(map),
      reloadButton: true,
      reloadFunction: this.reloadMapMap,
      locationButton: true,
      currentLocationState,
      locationFunction: this.currentLocation,
      goToState,
      gotoLocationButton: true,
      gotoLocationFunction: this.gotoLocation
    });

    drawMapInterestArea({
      aiInterestArea,
      aiInterestAreaLayer: this.aiInterestAreaLayer,
      isUpdate: true,
      leafletMap: this.mapMap
    });
    if (!isEmpty(aiInterestArea)) {
      this.mapMap.removeControl(this.aiInterestAreaDrawControl);
    }
    showGeometryEditControls({
      leafletMap: this.mapMap,
      drawControl: this.aiInterestAreaDrawControl,
      editControl: this.aiInterestAreaEditControl,
      defineGeometryActive: true,
      geometryLayer: this.aiInterestAreaLayer
    });

    if (this.mapMap.collapseButton) this.mapMap.collapseButton.expand();
    updateLayerMapState(false);
    Bert.alert('Map Updated!', 'success');
  };

  reloadMapMapSecond = async () => {
    const { baseMaps, layers, map, popupProp, updateLayerMapState } = this.props;
    const { currentLocationStateSecond, goToStateSecond } = this.state;
    const leafletObjectResults = await drawMapLayers({
      layers,
      baseMaps,
      popupProp,
      leafletMap: this.mapMapSecond,
      layersOverlayed: mapOps.areLayersOverlayed(map),
      layersToDisplay: this.layersToDisplaySecond,
      baseMapsToDisplay: this.baseMapsToDisplaySecond,
      isUpdate: true,
      baseMapsTransparency: mapOps.getBaseMapsTransparency(map),
      layersTransparency: mapOps.getLayersTransparency(map),
      baseMapsZoom: mapOps.getBaseMapsZoom(map),
      layersZoom: mapOps.getLayersZoom(map),
      layerVisibilitySettings: mapOps.getLayersVisibility(map)
    });
    this.layersToDisplaySecond = leafletObjectResults.newLayersToDraw;
    this.baseMapsToDisplaySecond = leafletObjectResults.newBaseMapsToDraw;
    drawCustomButtons({
      map,
      type: 'map',
      leafletMap: this.mapMapSecond,
      layers,
      layersToDisplay: this.layersToDisplaySecond,
      baseMaps,
      baseMapsToDisplay: this.baseMapsToDisplaySecond,
      baseMapsZoom: mapOps.getBaseMapsZoom(map),
      layersZoom: mapOps.getLayersZoom(map),
      reloadButton: true,
      reloadFunction: this.reloadMapMapSecond,
      locationButton: true,
      currentLocationState: currentLocationStateSecond,
      locationFunction: this.currentLocationSecond,
      goToState: goToStateSecond,
      gotoLocationButton: true,
      gotoLocationFunction: this.gotoLocationSecond
    });

    if (this.mapMapSecond.collapseButton) this.mapMapSecond.collapseButton.expand();
    updateLayerMapState(false);
    Bert.alert('Map Updated!', 'success');
  };

  async loadClientModules() {
    if (Meteor.isClient) {
      L = await import('leaflet');
      await import('leaflet.sync');
      MiniMap = (await import('leaflet-minimap')).default;
      ({
        addDrawEventListenersMaps,
        createGeometryDrawControlsMaps,
        customHomeButton,
        drawCustomButtons,
        drawMapLayers,
        drawMapInterestArea,
        getBBoxFromCoordsAndZoom,
        getMapCenter,
        showGeometryEditControls
      } = await import('../../../modules/leaflet-operations'));
      this.setState({ clientModulesReady: true });
    }
  }

  render() {
    const { baseMaps, deployEnv, isAtlas, isFullScreen, layers, map } = this.props;

    const showBaseMapSelector = mapOps.showBaseMapSelector(map) && !isEmpty(baseMaps);
    const showLayerSelector = mapOps.showLayerSelector(map) && !isEmpty(layers);

    const mapId = isAtlas ? this.randomMapId : 'mapMap';
    const mapIdSecond = isAtlas ? this.randomMapId : 'mapMapSecond';

    let numberOfButtonsRight = 0;
    if (showBaseMapSelector) numberOfButtonsRight += 1;
    if (showLayerSelector) numberOfButtonsRight += 1;

    return (
      <>
        <Row width="100%">
          <Col style={{ backgroundColor: 'white', width: '100%' }}>
            <LeafletMap
              deployEnv={deployEnv}
              headerType="9"
              isAtlas={isAtlas}
              isFullScreen={isFullScreen}
              mapId={mapId}
              ref={this.mapMapComponent}
              updateMapState={this.updateMapState}
              {...this.props}
            />
            <ButtonOnMap numberOfButtonsRight={numberOfButtonsRight}>
              <div
                onClick={this.updateMapCenter}
                title="Reload initial map position"
                role="button"
                onKeyPress={() => ''}
                tabIndex={0}
              >
                <img
                  src="/maps-buttons/flecha_ubicacion.svg"
                  style={{ height: '34px', width: '34px', cursor: 'pointer' }}
                  alt="Update Map Center"
                />
              </div>
            </ButtonOnMap>
          </Col>
          <Col style={{ backgroundColor: 'white', width: '100%' }}>
            <LeafletMapSecondSync
              deployEnv={deployEnv}
              headerType="1"
              isAtlas={isAtlas}
              isFullScreen={isFullScreen}
              mapId={mapIdSecond}
              ref={this.mapMapComponentSecond}
              updateMapState={this.updateMapStateSecond}
              {...this.props}
            />
            <ButtonOnMap numberOfButtonsRight={numberOfButtonsRight}>
              <div
                onClick={this.updateMapSecondCenter}
                title="Reload initial map position"
                role="button"
                onKeyPress={() => ''}
                tabIndex={0}
              >
                <img
                  src="/maps-buttons/flecha_ubicacion.svg"
                  style={{ height: '34px', width: '34px', cursor: 'pointer' }}
                  alt="Update Map Center"
                />
              </div>
            </ButtonOnMap>
          </Col>
        </Row>
      </>
    );
  }
}

MapContainerSyncMap.defaultProps = {
  popupProp: false,
  externalBoton: false,
  isAtlas: false,
  isFullScreen: false,
  updateLayerMapState: () => {},
  updateLocation: () => {},
  userControlSetting: {}
};

MapContainerSyncMap.propTypes = {
  baseMaps: PropTypes.array.isRequired,
  deployEnv: PropTypes.string.isRequired,
  externalBoton: PropTypes.bool,
  isAtlas: PropTypes.bool,
  isFullScreen: PropTypes.bool,
  layers: PropTypes.array.isRequired,
  map: PropTypes.object.isRequired,
  popupProp: PropTypes.bool,
  updateLayerMapState: PropTypes.func,
  updateLocation: PropTypes.func,
  userControlSetting: PropTypes.object
};

export default MapContainerSyncMap;
